/* sc-cart-preview.js
 * Vanilla port of LIVE snippets/cart-preview.liquid inline script.
 * Delegated events on document survive Shrine <cart-items> innerHTML swaps
 * when quantity changes. No jQuery; uses textContent (not innerHTML) to
 * safely populate modal from data-* attrs.
 */
(function () {
  if (window.__scCartPreviewInstalled) return;
  window.__scCartPreviewInstalled = true;

  var REVIEWS = [
    'I show it off everywhere I go!',
    'I smile every time I pick up my phone!',
    'Everyone asks where I got my case!',
    'My grandkids love seeing their names on it!',
    "Best thing I've bought for myself!",
    'Absolutely love it!',
    'So beautiful, worth every penny!',
    'Exceeded my expectations!'
  ];

  var TYPE_CONFIG = {
    'phone case': { title: 'Your phone case looks great!', subtext: 'One-of-a-kind, made just for you', showRating: true },
    'tough case': { title: 'Your phone case looks great!', subtext: 'One-of-a-kind, made just for you', showRating: true },
    'tshirt':     { title: 'Your t-shirt looks great!',    subtext: 'One-of-a-kind, made just for you', showRating: true },
    't-shirt':    { title: 'Your t-shirt looks great!',    subtext: 'One-of-a-kind, made just for you', showRating: true },
    'blanket':    { title: 'Your blanket looks great!',    subtext: 'One-of-a-kind, made just for you', showRating: true },
    'mug':        { title: 'Your mug looks great!',        subtext: 'One-of-a-kind, made just for you', showRating: true },
    'magsafe':    { title: 'MagSafe Upgrade',              subtext: 'Fast, easy wireless charging for your case.', showRating: false },
    'giftbox':    { title: 'Luxury Gift Box',              subtext: 'Elevate every moment with an elegant gift box.', showRating: false }
  };

  function parseMoney(str) {
    if (!str) return null;
    var num = parseFloat(String(str).replace(/[^0-9.]/g, ''));
    return isNaN(num) ? null : num;
  }

  function qs(sel, root) { return (root || document).querySelector(sel); }

  function randomReview() {
    return REVIEWS[Math.floor(Math.random() * REVIEWS.length)];
  }

  function setText(sel, value) {
    var el = qs(sel);
    if (el) el.textContent = value == null ? '' : value;
  }

  function showEl(sel, displayValue) {
    var el = qs(sel);
    if (el) el.style.display = displayValue || 'block';
  }

  function hideEl(sel) {
    var el = qs(sel);
    if (el) el.style.display = 'none';
  }

  function applyMessaging(trigger) {
    var productType = (trigger.getAttribute('data-product-type') || '').toLowerCase().trim();
    var productTitle = trigger.getAttribute('data-title') || '';
    var productDesc = trigger.getAttribute('data-description') || '';
    var cfg = TYPE_CONFIG[productType];

    if (cfg) {
      setText('.sc-preview-modal__title', cfg.title);
      setText('.sc-preview-modal__subtext', cfg.subtext);
      showEl('.sc-preview-modal__subtext');
      if (cfg.showRating) {
        setText('.sc-preview-modal__review', '"' + randomReview() + '"');
        showEl('.sc-preview-modal__social');
      } else {
        hideEl('.sc-preview-modal__social');
      }
      return;
    }

    if (productTitle && productTitle.toLowerCase().indexOf('shipping protection') !== -1) {
      setText('.sc-preview-modal__title', 'Shipping Protection');
      setText('.sc-preview-modal__subtext', 'Protect your order from damage, loss, or theft during shipping.');
      showEl('.sc-preview-modal__subtext');
      hideEl('.sc-preview-modal__social');
      return;
    }

    if (productTitle) {
      setText('.sc-preview-modal__title', productTitle);
      setText('.sc-preview-modal__subtext', productDesc || '');
      showEl('.sc-preview-modal__subtext');
      hideEl('.sc-preview-modal__social');
      return;
    }

    setText('.sc-preview-modal__title', 'Your phone case looks great!');
    setText('.sc-preview-modal__subtext', 'One-of-a-kind, made just for you');
    showEl('.sc-preview-modal__subtext');
    setText('.sc-preview-modal__review', '"' + randomReview() + '"');
    showEl('.sc-preview-modal__social');
  }

  function applyPrice(trigger) {
    var price = trigger.getAttribute('data-price') || '';
    var comparePrice = trigger.getAttribute('data-compare-price') || '';
    var priceBlock = qs('.sc-preview-modal__price');
    if (!priceBlock) return;

    var priceNum = parseMoney(price);
    var compareNum = parseMoney(comparePrice);

    if (priceNum && compareNum && compareNum > priceNum) {
      var savePct = Math.round(((compareNum - priceNum) / compareNum) * 100);
      setText('.sc-preview-modal__compare-price', comparePrice);
      setText('.sc-preview-modal__current-price', price);
      setText('.sc-preview-modal__save-badge', 'SAVE ' + savePct + '%');
      priceBlock.style.display = 'flex';
    } else {
      priceBlock.style.display = 'none';
    }
  }

  // Hero image authority (owner 2026-09-03 / 2026-09-08: never the product mockup; instant paint from any DECODED validated PZ image, white stage + spinner only while nothing is decoded yet).
  //
  // Source order per trigger: validated committed preview (data-hero-image = `_pz_preview`) is the
  // final hero authority; the validated cart thumb (data-hero-fallback / data-image = `_pz_thumb`) is
  // the instant first paint when it is the only decoded candidate and the fallback when the preview
  // fails; the product photo (data-photo-fallback) is NEVER a candidate (owner 03/09: no mockup); then
  // a static reassurance message. Every open paints synchronously from an already
  // DECODED image node held in bounded page memory (never the previous line's pixels); when only the
  // thumb is decoded, the preview keeps decoding off-screen and is swapped in atomically (node
  // replacement) as soon as it is ready; when nothing is decoded the stage is white with a spinner.
  // Same-URL reopen reuses the retained decoded node, so no new hero request is issued (`private,
  // no-store` responses are never re-fetched here; nothing is persisted: no Cache API / localStorage /
  // service worker — page memory only, bounded and evicted oldest-first). Priming starts when triggers
  // appear and on pointer/focus intent so the normal click path finds the preview already decoded.
  var HERO_LOAD_TIMEOUT_MS = 20000;
  var HERO_RETRY_COOLDOWN_MS = 5000;
  // R1 C2d (owner 18/09 04:15 VN, durable image UI only — window.__pzDurableImageUi === true, OFF = LIVE
  // behaviour byte-for-byte in every code path): right after an add the server preview/thumb are still
  // `pending` (404 + X-Pz-Artifact-Status: pending, ready within ~6 s). Instead of the reassurance text,
  // (1) the hero paints INSTANTLY from the line's LOCAL thumb (the data URL sc-cart-thumb.js painted in the
  // drawer / kept in sessionStorage: same design, no flash); (2) while nothing local exists the stage shows
  // the spinner; server candidates are retried on a bounded ladder 1/2/4/8 s (preview, then thumb), wall
  // 20 s from the open, ONE flight per modal, stopped on close; (3) only when the wall passes with nothing
  // painted does the static text appear. No request beyond the image retries; no runtime/commerce change.
  var DURABLE_RETRY_LADDER_MS = [1000, 2000, 4000, 8000];
  var DURABLE_RETRY_WALL_MS = 20000;
  var DURABLE_FETCH_TIMEOUT_MS = 8000;   // C2d-b(1): a hung fetch can never freeze the spinner
  function durableUi() { try { return window.__pzDurableImageUi === true; } catch (e) { return false; } }
  var durableRetry = null;   // { seq, timer } — the single retry-ladder timer of the current open
  function stopDurableRetry() { if (durableRetry && durableRetry.timer) clearTimeout(durableRetry.timer); durableRetry = null; }
  // C2d-c(1): an INDEPENDENT wall timer, armed once at modal open, forces the terminal fallback at exactly
  // openedAt + 20 s no matter what any fetch/decode is doing (the ladder-driven check alone let a fetch or
  // decode still in flight keep the spinner past 20 s). Cleared on close and on a new open.
  var durableWall = null;    // { seq, timer, expire }
  function stopDurableWall() { if (durableWall && durableWall.timer) clearTimeout(durableWall.timer); durableWall = null; }
  // C2d-b(2)+c(2): every in-flight retry (fetch AND its decode) is tracked so close/reopen/wall force-settle
  // it through finishFlight (no 4-flight pileup, no fetch/decode that outlives the deadline); a URL already
  // in flight is deduped onto the same flight (one network flight per URL). flight.cancel is the single
  // terminal used by the flight's own timeout, by abortHeroFlights (close/reopen) and by the wall.
  var heroFlights = {};   // url -> { controller, timer, waiters:[], cancel }
  function abortHeroFlights(keepUrls) {
    var urls = Object.keys(heroFlights);
    for (var i = 0; i < urls.length; i++) {
      var f = heroFlights[urls[i]];
      // Legacy image priming survives close; a durable open adopts its own pending URLs
      // instead of cancelling and immediately issuing the same no-store GET again.
      if ((keepUrls && keepUrls.indexOf(urls[i]) !== -1) || (f && f.primed && !durableUi())) continue;
      if (f && f.cancel) f.cancel();
    }
  }
  // Retry load = ONE fetch (no-store, no cookies, abortable) per URL: a real request (an errored <img> for
  // the same URL is reused from memory by the browser), decoded into a cached hero node on 200. The flight
  // timeout aborts the fetch AND caps the decode (a loaded blob whose decode() hangs still terminates the
  // flight), so a flight can never sit forever; close/reopen/wall cancel it the same way.
  function fetchHero(url, onSettle) {
    var entry = heroCache[url];
    if (entry && entry.state === 'ready') { entry.order = ++heroOrder; onSettle(entry); return; }
    var existing = heroFlights[url];
    if (existing) { existing.waiters.push(onSettle); return; }   // dedupe: attach to the live flight
    if (typeof fetch !== 'function' || typeof URL === 'undefined' || typeof URL.createObjectURL !== 'function') { onSettle(null); return; }
    var controller = (typeof AbortController === 'function') ? new AbortController() : null;
    var objectUrl = null;
    var imgNode = null;
    var flightDone = false;
    var flight = heroFlights[url] = { controller: controller, timer: null, waiters: [onSettle], cancel: null };
    function finishFlight(result) {
      if (flightDone) return; flightDone = true;
      if (flight.timer) { clearTimeout(flight.timer); flight.timer = null; }
      if (imgNode) { imgNode.onload = null; imgNode.onerror = null; }
      var ready = !!(result && result.state === 'ready');
      if (!ready && objectUrl) { try { URL.revokeObjectURL(objectUrl); } catch (err) { /* best-effort */ } }
      if (heroFlights[url] === flight) delete heroFlights[url];
      var ws = flight.waiters; flight.waiters = [];
      for (var i = 0; i < ws.length; i++) { try { ws[i](result); } catch (err) { /* observer only */ } }
    }
    flight.cancel = function () { try { if (controller) controller.abort(); } catch (e) { /* best-effort */ } finishFlight(null); };
    // One timer caps the WHOLE flight (fetch + decode). If the fetch is still open it also aborts it.
    flight.timer = setTimeout(flight.cancel, DURABLE_FETCH_TIMEOUT_MS);
    fetch(url, { mode: 'cors', cache: 'no-store', credentials: 'omit', signal: controller ? controller.signal : undefined }).then(function (res) {
      if (!res || res.status !== 200) return null;
      return res.blob();
    }).then(function (blob) {
      if (flightDone) return;   // cancelled (close/wall/timeout) while the response was in flight
      if (!blob || !blob.size) { finishFlight(null); return; }
      objectUrl = URL.createObjectURL(blob);
      var node = imgNode = document.createElement('img');
      node.className = 'sc-preview-modal__image';
      node.setAttribute('decoding', 'async');
      node.setAttribute('alt', '');
      var e = { url: url, node: node, state: 'ready', order: ++heroOrder, waiters: [], timer: null };
      var onReady = function () { if (flightDone) return; node.onload = null; node.onerror = null; heroCache[url] = e; evictHeroCache(); finishFlight(e); };
      node.onerror = function () { if (flightDone) return; node.onload = null; node.onerror = null; finishFlight(null); };
      // A decode() that hangs never calls onReady; the flight timeout / wall / close then cancel via
      // flight.cancel -> finishFlight(null), so no flight is left spinning on a stuck decode.
      node.onload = function () { if (typeof node.decode === 'function') { try { node.decode().then(onReady, onReady); } catch (err) { onReady(); } } else onReady(); };
      node.setAttribute('src', objectUrl);
    }).catch(function () { finishFlight(null); });
  }
  function stateIdOf(trigger) {
    var img = trigger.querySelector ? trigger.querySelector('img[data-pz-state-id]') : null;
    var sid = img ? String(img.getAttribute('data-pz-state-id') || '') : '';
    if (!sid) { var m = /\/(?:preview|thumb)\/([a-z2-7]{26})\./.exec(String(trigger.getAttribute('data-hero-image') || '')); sid = m ? m[1] : ''; }
    return /^[a-z2-7]{26}$/.test(sid) ? sid : '';
  }
  // The line's local thumb: the data URL already painted for this state in the drawer/cart, else the
  // sessionStorage copy sc-cart-thumb.js keeps for the session. Never a server URL, never another line.
  function localHeroOf(trigger) {
    var sid = stateIdOf(trigger);
    if (!sid) return '';
    var imgs = document.querySelectorAll('img[data-pz-state-id="' + sid + '"]');
    for (var i = 0; i < imgs.length; i++) { var src = imgs[i].currentSrc || imgs[i].getAttribute('src') || ''; if (src.indexOf('data:image') === 0) return src; }
    try { var stored = window.sessionStorage.getItem('pz_thumb_' + sid); if (stored && stored.indexOf('data:image') === 0) return stored; } catch (e) { /* best-effort */ }
    return '';
  }
  var HERO_CACHE_MAX = 16;   // decoded nodes retained (thumb + preview per line); oldest evicted
  function now() { return Date.now(); }
  var heroCache = {};        // url -> { url, node, state: 'pending'|'ready'|'failed', order, timer }
  var heroOrder = 0;
  var openSequence = 0;      // bumps on every open; async completions check it before touching DOM
  var openAuthority = '';    // authority URL of the current/last open

  function heroSourcesOf(trigger) {
    var authority = String(trigger.getAttribute('data-hero-image') || '').trim();
    var thumb = String(trigger.getAttribute('data-hero-fallback') || trigger.getAttribute('data-image') || '').trim();
    var photo = String(trigger.getAttribute('data-photo-fallback') || '').trim();
    var chain = [];
    [authority, thumb, photo].forEach(function (u) { if (u && chain.indexOf(u) === -1) chain.push(u); });
    return { authority: authority, thumb: thumb !== authority ? thumb : '', photo: photo, chain: chain };
  }

  function evictHeroCache() {
    var keys = Object.keys(heroCache);
    if (keys.length <= HERO_CACHE_MAX) return;
    keys.sort(function (a, b) { return heroCache[a].order - heroCache[b].order; });
    while (keys.length > HERO_CACHE_MAX) {
      var k = keys.shift();
      var entry = heroCache[k];
      var current = qs('.sc-preview-modal__image');
      if (entry && entry.node && entry.node === current) continue; // never evict the node on stage
      // Keep the flight deadline alive; settle owns handler/waiter cleanup.
      delete heroCache[k];
    }
  }

  // Load + decode `url` into a detached image node kept in page memory. Idempotent per URL;
  // a failed entry may be retried once per later intent/open. `onSettle` runs for this caller only.
  function primeHero(url, onSettle) {
    if (!url) { if (onSettle) onSettle(null); return null; }
    var entry = heroCache[url];
    if (entry && entry.state === 'ready') { entry.order = ++heroOrder; if (onSettle) onSettle(entry); return entry; }
    var existing = heroFlights[url];
    if (existing) { if (entry) entry.order = ++heroOrder; if (onSettle) existing.waiters.push(onSettle); return entry || null; }
    if (entry && entry.state === 'failed' && (now() - entry.failedAt) < HERO_RETRY_COOLDOWN_MS) { if (onSettle) onSettle(entry); return entry; }
    var node = document.createElement('img');
    node.className = 'sc-preview-modal__image';
    node.setAttribute('decoding', 'async');
    node.setAttribute('alt', '');
    entry = heroCache[url] = { url: url, node: node, state: 'pending', order: ++heroOrder, waiters: onSettle ? [onSettle] : [], timer: null };
    // Priming and durable retries share the SAME pending registry, including when the
    // bounded decoded-node cache evicts this entry before its load/decode settles.
    var flight = heroFlights[url] = { primed: true, waiters: entry.waiters, cancel: null };
    evictHeroCache();
    var settled = false;
    function settle(state) {
      if (settled) return;
      settled = true;
      if (entry.timer) { clearTimeout(entry.timer); entry.timer = null; }
      node.onload = null; node.onerror = null;
      entry.state = state;
      if (state === 'failed') entry.failedAt = now();
      if (heroFlights[url] === flight) delete heroFlights[url];
      if (state === 'ready') { heroCache[url] = entry; evictHeroCache(); }
      var waiters = flight.waiters; flight.waiters = []; entry.waiters = [];
      for (var i = 0; i < waiters.length; i++) { try { waiters[i](entry); } catch (error) { /* observer only */ } }
    }
    flight.cancel = function () { settle('failed'); node.removeAttribute('src'); };
    entry.timer = setTimeout(flight.cancel, HERO_LOAD_TIMEOUT_MS);
    node.onerror = function () { settle('failed'); };
    node.onload = function () {
      // A decode() rejection after a successful load still leaves a paintable image; treat as ready.
      var ok = function () { settle('ready'); };
      if (typeof node.decode === 'function') {
        try { node.decode().then(ok, ok); } catch (error) { ok(); }
      } else ok();
    };
    node.setAttribute('src', url);
    return entry;
  }

  // Edit presentation reuses this same immutable decoded preview node/flight rather
  // than cloning a no-store src into another GET. No second image cache is created.
  window.__scCartPreviewPrimeHero = primeHero;

  function primeTrigger(trigger) {
    var src = heroSourcesOf(trigger);
    if (src.thumb) primeHero(src.thumb);
    if (src.authority) primeHero(src.authority);
  }

  var primeScanTimer = null;
  function primeVisibleTriggers() {
    primeScanTimer = null;
    var triggers = document.querySelectorAll('.sc-preview-show[data-hero-image]');
    var seen = 0;
    for (var i = 0; i < triggers.length && seen < HERO_CACHE_MAX; i++) {
      var t = triggers[i];
      var url = t.getAttribute('data-hero-image');
      if (!url) continue;
      if (!heroCache[url]) seen++;
      primeTrigger(t);
    }
  }
  function schedulePrimeScan() {
    if (primeScanTimer) return;
    primeScanTimer = setTimeout(primeVisibleTriggers, 60);
  }

  // Put `node` on stage as the hero, replacing whatever is there (atomic; the old pixels are gone
  // in the same frame the new ones appear). No-op when the node is already on stage.
  function mountHero(node, alt, sourceLabel) {
    var stage = qs('[data-sc-preview-stage]');
    var current = qs('.sc-preview-modal__image');
    if (!stage || !node) return;
    node.className = 'sc-preview-modal__image';
    node.setAttribute('alt', alt);
    node.setAttribute('data-sc-preview-source', sourceLabel);
    node.hidden = false;
    if (current === node) return;
    if (current && current.parentNode === stage) stage.replaceChild(node, current);
    else stage.appendChild(node);
  }

  function setStageState(state) {
    var stage = qs('[data-sc-preview-stage]');
    var spinner = qs('.sc-preview-modal__spinner');
    var status = qs('.sc-preview-modal__unavailable');
    if (stage) stage.setAttribute('data-sc-preview-state', state);
    if (spinner) spinner.hidden = state !== 'loading';
    if (status) status.hidden = state !== 'unavailable';
  }
  function setUnavailable(on) { setStageState(on ? 'unavailable' : 'image'); }

  // Resolve the best currently DECODED source for the trigger, in authority order.
  function readyEntry(url) { var e = url && heroCache[url]; return e && e.state === 'ready' ? e : null; }

  // Owner 03/09 + 08/09: the stage never shows the product MOCKUP (that was the misleading flash).
  // Whatever validated PZ image is already DECODED paints instantly — the committed preview first,
  // else the cart thumb (speed); only when nothing is decoded yet is the stage white with a spinner
  // ("slow" case). The preview keeps decoding off-screen and replaces a painted thumb atomically; a
  // thumb never replaces a preview; the product photo is never a candidate. Preview failed -> thumb;
  // every candidate failed with nothing painted -> static unavailable.
  function showHero(trigger) {
    var seq = ++openSequence;
    var src = heroSourcesOf(trigger);
    var alt = trigger.getAttribute('data-title') || 'Personalized design preview';
    openAuthority = src.authority;
    var current = qs('.sc-preview-modal__image');
    var order = [];
    if (src.authority) order.push(src.authority);
    if (src.thumb) order.push(src.thumb);
    if (!order.length) { if (current) current.hidden = true; setStageState('unavailable'); return; }
    var mountedIdx = order.length; // best (lowest) candidate index on stage so far
    function paint(idx, entry) {
      mountedIdx = idx;
      mountHero(entry.node, alt, idx === 0 ? 'hero' : 'thumb');
      setStageState('image');
    }
    // 1) instant paint from the best already-decoded candidate (authority order)
    for (var i = 0; i < order.length; i++) {
      var ready = readyEntry(order[i]);
      if (ready) { paint(i, ready); break; }
    }
    if (mountedIdx === 0) return;
    var primed = mountedIdx; // candidates still worth loading: every index better than the mounted one
    var durable = durableUi();
    var localPainted = false;
    if (primed === order.length) {
      // C2d: nothing decoded yet — the line's LOCAL thumb (same design) paints instantly under the
      // durable UI; a server candidate that decodes later replaces it (local counts as the worst index).
      var local = durable ? localHeroOf(trigger) : '';
      if (local) {
        primeHero(local, function (entry) {
          if (seq !== openSequence || mountedIdx !== order.length || !entry || entry.state !== 'ready') return;
          localPainted = true;
          mountHero(entry.node, alt, 'local');
          setStageState('image');
        });
      }
      if (!localPainted) { if (current) current.hidden = true; setStageState('loading'); }
    }
    // 2) OFF / non-durable: prime every better candidate once in parallel; the first to decode paints,
    //    a better one that decodes later replaces it; all failed with nothing painted -> unavailable
    //    (this is the byte-identical LIVE behaviour when durableUi() is false).
    function primeRoundLegacy() {
      var failures = 0;
      for (var c = 0; c < primed; c++) {
        (function (idx) {
          primeHero(order[idx], function (entry) {
            if (seq !== openSequence) return; // a newer open owns the stage
            if (entry && entry.state === 'ready') { if (idx < mountedIdx) paint(idx, entry); return; }
            failures += 1;
            if (mountedIdx === order.length && failures >= primed) {
              var cur = qs('.sc-preview-modal__image');
              if (cur) cur.hidden = true;
              setStageState('unavailable');
            }
          });
        })(c);
      }
    }
    // 2') DURABLE (C2d-b): retry the best not-yet-ready server candidates on the ladder cadence but a
    //     TRUE 20 s wall measured from the open (fix 1); EVERY candidate better than what is mounted is
    //     retried independently, so a painted thumb is upgraded to the committed preview of the SAME line
    //     the instant it lands (fix 3); the static text appears only if the wall passes with nothing
    //     painted and no local design on stage. Close aborts all flights (fix 2, in closeModal).
    var openedAt = now();
    var deadline = openedAt + DURABLE_RETRY_WALL_MS;
    var ladderStep = 0;
    var walled = false;
    function finishWall() {
      if (seq !== openSequence) return;
      if (mountedIdx === order.length && !localPainted) {
        var cur = qs('.sc-preview-modal__image');
        if (cur) cur.hidden = true;
        setStageState('unavailable');
      }
    }
    // C2d-c(1): the independent wall — fires at exactly openedAt + 20 s, force-cancels every flight (a hung
    // fetch or a hung decode) and the ladder, then shows the text if nothing is on stage. This is the only
    // guarantee that the spinner cannot outlive 20 s regardless of network/decode state.
    function wallExpire() {
      if (durableWall && durableWall.seq === seq) durableWall = null;
      if (seq !== openSequence) return;
      walled = true;
      stopDurableRetry();
      abortHeroFlights();
      finishWall();
    }
    function scheduleNext() {
      if (walled || seq !== openSequence) return;
      if (mountedIdx === 0) return;                       // committed preview already on stage: done
      if (now() >= deadline) { finishWall(); return; }
      var base = DURABLE_RETRY_LADDER_MS[Math.min(ladderStep, DURABLE_RETRY_LADDER_MS.length - 1)];
      ladderStep += 1;
      var delay = Math.max(0, Math.min(base, deadline - now()));   // never overshoot the wall
      stopDurableRetry();
      durableRetry = { seq: seq, timer: setTimeout(function () {
        durableRetry = null;
        if (walled || seq !== openSequence || !isModalOpen()) return;
        retryRound();
      }, delay) };
    }
    function retryRound() {
      // No isModalOpen() guard here: round 0 runs synchronously from showHero, BEFORE openModal flips
      // the modal to display:block. Deferred rounds are gated on isModalOpen() inside their ladder timer.
      if (walled || seq !== openSequence) return;
      if (mountedIdx === 0) return;
      var targets = [];
      for (var t = 0; t < mountedIdx; t++) targets.push(t);   // only candidates better than what is mounted
      if (!targets.length) return;
      if (now() >= deadline) { finishWall(); return; }
      var pending = targets.length;
      targets.forEach(function (idx) {
        fetchHero(order[idx], function (entry) {
          if (seq !== openSequence) return;
          pending -= 1;
          if (entry && entry.state === 'ready' && idx < mountedIdx) paint(idx, entry);
          if (pending === 0) scheduleNext();
        });
      });
    }
    if (durable) {
      stopDurableWall();
      durableWall = { seq: seq, timer: setTimeout(wallExpire, DURABLE_RETRY_WALL_MS) };
      retryRound();
    } else primeRoundLegacy();
  }

  function openModal(trigger) {
    var modal = qs('.sc-preview-modal');
    if (!modal) return;
    stopDurableRetry();
    stopDurableWall();
    var src = heroSourcesOf(trigger);
    abortHeroFlights([src.authority, src.thumb]);
    showHero(trigger);
    applyMessaging(trigger);
    applyPrice(trigger);
    modal.style.display = 'block';
    modal.setAttribute('aria-hidden', 'false');
    var closeBtn = qs('.sc-preview-modal__close');
    if (closeBtn && typeof closeBtn.focus === 'function') {
      try { closeBtn.focus({ preventScroll: true }); } catch (error) { /* focus is best-effort */ }
    }
  }

  function closeModal() {
    var modal = qs('.sc-preview-modal');
    if (!modal) return;
    // Retain the decoded hero node on stage: a same-item reopen paints it again with no request.
    // Pending upgrades for this open are still allowed to land (they check openSequence, which is
    // unchanged by close); a later open of another line bumps the sequence and replaces the node.
    modal.style.display = 'none';
    modal.setAttribute('aria-hidden', 'true');
    stopDurableRetry();
    stopDurableWall();
    abortHeroFlights();   // C2d-b(2)+c: no fetch/decode/wall timer outlives the modal — reopen never doubles them
  }

  // Priming: when triggers appear (initial render + <cart-items>/drawer section replacement) and on
  // pointer/focus intent. Bounded by HERO_CACHE_MAX; no-ops when the URL is already cached.
  document.addEventListener('pointerover', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('.sc-preview-show') : null;
    if (t) primeTrigger(t);
  }, true);
  document.addEventListener('focusin', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('.sc-preview-show') : null;
    if (t) primeTrigger(t);
  }, true);
  document.addEventListener('touchstart', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('.sc-preview-show') : null;
    if (t) primeTrigger(t);
  }, { capture: true, passive: true });
  if (typeof MutationObserver === 'function' && document.body) {
    new MutationObserver(schedulePrimeScan).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedulePrimeScan);
  else schedulePrimeScan();

  function isModalOpen() {
    var modal = qs('.sc-preview-modal');
    return !!(modal && modal.style.display && modal.style.display !== 'none');
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.sc-preview-show');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      openModal(trigger);
      return;
    }

    var closeBtn = e.target.closest('.sc-preview-modal__close');
    if (closeBtn) {
      closeModal();
      return;
    }

    var modal = e.target.closest('.sc-preview-modal');
    if (modal && !e.target.closest('.sc-preview-modal__panel')) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isModalOpen()) closeModal();
  });
})();

/* Cart countdown — 10 minute urgency timer.
 * Install-once IIFE, sessionStorage persist, re-queries DOM each tick
 * to survive <cart-items> innerHTML swap on quantity update.
 */
(function () {
  if (window.__scCartCountdownInstalled) return;
  window.__scCartCountdownInstalled = true;

  var storageKey = 'sc_cart_countdown_end';
  var duration = 10 * 60 * 1000;
  var endTime;

  try {
    var stored = sessionStorage.getItem(storageKey);
    if (!stored || parseInt(stored, 10) < Date.now()) {
      endTime = Date.now() + duration;
      sessionStorage.setItem(storageKey, String(endTime));
    } else {
      endTime = parseInt(stored, 10);
    }
  } catch (e) {
    endTime = Date.now() + duration;
  }

  function tick() {
    var timerEl = document.getElementById('cart-countdown-timer');
    if (!timerEl) return;
    var remaining = endTime - Date.now();
    if (remaining <= 0) {
      timerEl.textContent = '00:00';
      try { sessionStorage.removeItem(storageKey); } catch (e) {}
      var bar = document.getElementById('cart-countdown');
      if (bar && !bar.classList.contains('sc-cart-countdown-expired')) {
        bar.classList.add('sc-cart-countdown-expired');
        bar.innerHTML = 'Your items are still available — <strong>checkout now</strong> to secure your order!';
      }
      return;
    }
    var min = Math.floor(remaining / 60000);
    var sec = Math.floor((remaining % 60000) / 1000);
    timerEl.textContent = (min < 10 ? '0' : '') + min + ':' + (sec < 10 ? '0' : '') + sec;
  }

  tick();
  setInterval(tick, 1000);
})();
